import { Injectable } from '@angular/core';
import { Http, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class CompanyServiceA2 {

    private baseUrl: string = '../rest/company';
    constructor (
        private http: Http
    ) {}

    get(id) {
        return this.http.get(`${this.baseUrl}/${id}`)
            .map((res:any) => res.json());
    }

    getAllCompanies(){
        return this.http.get(`${this.baseUrl}/page`)
            .map((res:any) => res.json());
    }

    searchByNameLike(nameLike, language){
        let params = new URLSearchParams();
        params.append('nameLike', nameLike);
        params.append('language', language);
        return this.http.get(`${this.baseUrl}/search`, {search: params})
            .map((res:any) => res.json());

    }

    getCommercialExecutive(companyOid){
        return this.http
            .get(`${this.baseUrl}/${companyOid}/commercial-executive`)
            .map((res:any) => res.json());
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/core/company_a2.service.ts